var BlockView = require('views/block/base-block-view');

var TableView = BlockView.extend({
  initialize: function() {
    var self = this;
    var colHeaders = [];
    var rowHeaders = [];
    _.each(this.model.get('rows'), function(row, r_index) {
      _.each(row.cells, function(cell, c_index) {
        var cellContent = cell.description || cell.header || cell.blocks;
        if(row.header && cellContent) {
          cell.header = true;
          cell.scope = 'col';
          cell.id = self.model.cid + '-col-' + c_index + '-header';
          colHeaders[c_index] = colHeaders[c_index] || [];
          colHeaders[c_index].push(cell.id);
        } else if(cell.header && cellContent) {
          cell.scope = 'row';
          cell.id = self.model.cid + '-row-' + r_index + '-header';
          rowHeaders[r_index] = rowHeaders[r_index] || [];
          rowHeaders[r_index].push(cell.id);
          for(var i = c_index - 1; i >= 0; i--) {
            var prevCell = row.cells[i];
            prevCell.headers += ' ' + cell.id;
          }
        } else {
          var rHead = rowHeaders[r_index] ? rowHeaders[r_index].join(' ') : '';
          var cHead = colHeaders[c_index] ? colHeaders[c_index].join(' ') : '';
          cell.headers = rHead + ' ' + cHead;
        }
      });
    });
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    var self = this;
    _.each(this.model.get('rows'), function(row, r_index) {
      _.each(row.cells, function(cell, c_index) {
        self.renderNestedBlocks(self.model.get('cid') + '-cell-' + c_index + '-row-' + r_index + '-blocks', cell.blocks);
      });
    });

    if(this.model.get('highlight_columns')) {
      this.delegate('mouseover', '[data-column]', function(e) {
        var $target = $(e.currentTarget);
        $('[data-column="' + encodeURIComponent($target.attr('data-column')) + '"]').addClass('column-hover');
      });
      this.delegate('mouseout', '[data-column]', function(e) {
        var $target = $(e.currentTarget);
        $('[data-column="' + encodeURIComponent($target.attr('data-column')) + '"]').removeClass('column-hover');
      });
    }
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = TableView;